import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import { useUploadProductCataloguesMutation } from '../../../graphql/mutation/product/productCatalogue/uploadProductCataloguesMutation';
import { useUnpublishProductCataloguesMutation } from '../../../graphql/mutation/product/productCatalogue/unpublishProductCataloguesMutation';
import { useDeleteProductCataloguesMutation } from '../../../graphql/mutation/product/productCatalogue/deleteProductCataloguesMutation';
import { usePublishProductCataloguesMutation } from '../../../graphql/mutation/product/productCatalogue/publishProductCataloguesMutation';
import BaseAttachmentUpload from './_module/BaseAttachmentUpload';
import useNotification from '../_hook/useNotification';

interface IProps {
  productId: string;
  catalogues: {
    status: boolean;
    filename: string;

    filenameUrl?: string;
  }[];
}

export default function ProductCatalogueUpload(props: IProps) {
  const { productId, catalogues } = props;
  const [uploadingCount, setUploadingCount] = useState(0);
  const { t } = useTranslation();
  const { notification } = useNotification();
  const queryFragment = `updatedProduct {
				_id
                media {
                    attachments {
                        status
                        filename
                        
                        filenameUrl
                    }
                }
			}`;
  const [uploadProductCataloguesMutation] = useUploadProductCataloguesMutation(
    queryFragment,
    {
      onCompleted: () => {
        setUploadingCount(0);
      },
      onError: (e) => {
        setUploadingCount(0);
        notification.error(e.message);
      },
    }
  );
  const [deleteProductCataloguesMutation] = useDeleteProductCataloguesMutation(
    queryFragment,
    {
      onError: (e) => {
        notification.error(e.message);
      },
    }
  );
  const [
    publishProductCataloguesMutation,
  ] = usePublishProductCataloguesMutation(queryFragment, {
    onError: (e) => {
      notification.error(e.message);
    },
  });
  const [
    unpublishProductCataloguesMutation,
  ] = useUnpublishProductCataloguesMutation(queryFragment, {
    onError: (e) => {
      notification.error(e.message);
    },
  });

  // 200KB
  const maximumUploadSize = 5120000;
  const acceptedUploadFileTypes =
    'image/png, image/jpeg, image/jpg, image/gif, application/pdf, application/msword';

  function onUpload(fileList: FileList | null) {
    if (fileList && fileList.length) {
      setUploadingCount(uploadingCount + fileList.length);
      uploadProductCataloguesMutation({
        variables: {
          _id: productId,
          catalogues: fileList,
        },
      });
    }
  }

  return (
    <>
      <Typography variant="h6">
        {t('upload')} {t('catalogue')}
      </Typography>
      <BaseAttachmentUpload
        color="primary"
        attachments={catalogues}
        maximumUploadSize={maximumUploadSize}
        uploadInfo={{
          ratio: ' 210:297 ',
          size: '5MB',
          acceptedUploadFileTypes,
        }}
        uploadingCount={uploadingCount}
        onUpload={onUpload}
        onDelete={(filename) => {
          deleteProductCataloguesMutation({
            variables: {
              _id: productId,
              catalogueFilenames: [filename],
            },
          });
        }}
        onPublish={(filenames) => {
          publishProductCataloguesMutation({
            variables: {
              _id: productId,
              filenames,
            },
          });
        }}
        onUnpublish={(filenames) => {
          unpublishProductCataloguesMutation({
            variables: {
              _id: productId,
              filenames,
            },
          });
        }}
      />
    </>
  );
}
